import {
  INVITE_WORKERS_PERMISSIONS,
  MANAGEMENT_PERMISSIONS,
  OnboardingStatusFilter,
  TabItem,
} from '@vyce/core/src/types';

export const USER_MANAGEMENT_TABS: TabItem[] = [
  {
    label: 'Users',
    link: '/user-management/users',
    // TODO: may belong on management:can_view_all_workers once the backend
    // confirms whether that synthetic marker is the intended gate (catalogue D3).
    permission: MANAGEMENT_PERMISSIONS.LIST_STAFF,
  },
  {
    label: 'Company Admins',
    link: '/user-management/admins',
    permission: MANAGEMENT_PERMISSIONS.LIST_STAFF,
  },
  {
    label: 'Invites',
    link: '/user-management/company-invites',
    permission: INVITE_WORKERS_PERMISSIONS,
  },
];

export type UserDomain = 'all' | 'payroll' | 'teams' | 'time';

export interface UserDomainOption {
  value: UserDomain;
  label: string;
  module?: string;
}

export const USER_DOMAIN_OPTIONS: UserDomainOption[] = [
  { value: 'all', label: 'All' },
  { value: 'payroll', label: 'Payroll', module: 'Payroll' },
  { value: 'teams', label: 'Teams', module: 'Teams' },
  { value: 'time', label: 'Time & Attendance', module: 'Time&Attendance' },
];

export const isUserDomain = (value: string | null): value is UserDomain =>
  value === 'all' || value === 'payroll' || value === 'teams' || value === 'time';

// Display values of the Onboarding filter mapped to the wire enum.
// "Recommended pending" is deliberately not offered — recommended fields are not surfaced yet.
export const ONBOARDING_FILTER_MAP: Record<string, OnboardingStatusFilter> = {
  Ready: 'ready',
  'Missing required info': 'required_missing',
};

export const ONBOARDING_FILTER_VALUES = ['', ...Object.keys(ONBOARDING_FILTER_MAP)];
